import { useCallback } from "react";
import { TransactionProxyObject } from "./AddTransactionsModal";

interface Change<T> {
    field: keyof T;
    value: string | number | string[] | null;
}

interface UpdateAndReturnNewLineParams<T> {
    line: T;
    changes: Array<Change<T>>;
    fillEmptyFieldsAutomatically?: boolean;
}

export function useUpdateAndReturnNewLineCallback() {
    return useCallback(
        ({
            line,
            changes,
        }: UpdateAndReturnNewLineParams<TransactionProxyObject>) => {
            const newLine: TransactionProxyObject = structuredClone(line);

            changes.forEach((change) => {
                (newLine as Record<keyof TransactionProxyObject, unknown>)[
                    change.field
                ] = change.value;
            });

            return newLine;
        },
        [],
    );
}
